import React from "react";

const ShippingDelivery = () => {
  return (
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      {/* breadcrumb start */}
      <section id="h1-breadcrumb z-10">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative breadcrumbImg pb-16 md:pb-24">
          <div className="theme-container mx-auto h-fit w-fit relative z-10">
            <div className="mt-[120px] md:mt-[172px] w-fit mx-auto relative z-10">
              <h1 className="px-5 py-2 border border-[#AF493E20] text-[#AF493E] font-medium rounded-[30px] w-fit mx-auto">
                Care Nova
              </h1>
              <h1 className="text-main-black mt-4 text-34 sm:text-48 font-semibold w-full text-center">
                Shipping And Delivery Policy
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}
      <div className="w-full h4-pricing-wrapper pb-[60px] md:pb-[8rem] max-md:pt-[60px] md:pt-[160px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="md:px-[100px]">
            <i style={{ fontSize: 14 }}>Last updated on June 24th 2025</i>
                <ul>
                  <li>
                    1. Service orders are fulfilled by our empaneled health
                    providers through their qualified technicians or
                    phlebotomist or staff.
                  </li>
                  <li>
                    2. Product orders are shipped through registered domestic
                    courier companies and /or speed post only.
                  </li>
                  <li>
                    3. Orders are shipped within 0-7 days or as per the delivery
                    date agreed at the time of order confirmation and delivering
                    of the shipment subject to Courier Company / post office
                    norms.
                  </li>
                  <li>
                    4. We are not liable for
                    any delay in delivery by the courier company / postal
                    authorities and only guarantees to hand over the consignment
                    to the courier company or postal authorities within 0-7 days
                    rom the date of the order and payment or as per the delivery
                    date agreed at the time of order confirmation.
                  </li>
                  <li>
                    5. Delivery of all orders will be to the address provided by
                    the buyer.
                  </li>
                  <li>
                    6. Delivery of our services will be confirmed on your mail
                    ID as specified during registration. For any issues in
                    utilizing our services you may contact our helpdesk on
                    <a href="tel:919214562942" style={{ display: "inline" }}>
                    +91 9214562942
                    </a> <span> or </span> <a
                      href="mailto:support@carenova.in"
                      style={{ display: "inline" }}
                    >
                      support@carenova.in
                    </a>
                    .
                  </li>
                </ul>
            </div>
          </div>
        </div>
        <div className="shape-1 absolute left-40 top-96 z-10">
          <img src="assets/images/home-four/shape-1.webp" alt="" />
        </div>
        <div className="shape-2 absolute right-96 top-96 z-10">
          <img src="assets/images/home-four/shape-2.webp" alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-3.webp" alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-4.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default ShippingDelivery;
